export enum ShareOptions {
  Yes = 'Yes',
  No = 'No',
  NA = 'N/A',
}
